/* eslint-disable no-sparse-arrays */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../views/Index.vue'),
         meta: {
        keepAlive: true // 需要缓存
      }
    },
    // company
    {
        path: '/team',
        name: 'Company',
        component: () => import('../views/company/team.vue'),
         meta: {
        keepAlive: true // 需要缓存
      }
    },
    {
        path: '/aboutUs',
        name: 'About Us',
        component: () => import('../views/company/aboutUs.vue'),
         meta: {
        keepAlive: true // 需要缓存
      }
    },
    {
        path: '/webinar',
        name: 'Webinars',
        component: () => import('../views/webinar.vue')
    },
    {
        path: '/asia',
        name: 'Asia Access',
        component: () => import('../views/company/Asia.vue'),
         meta: {
        keepAlive: true // 需要缓存
      }
    },
    // products
  
    {
        path: '/physicians',
        name: 'physicians',
        component: () => import('../views/products/physicians.vue')
    },
    {
        path: '/patients',
        name: 'Patients',
        component:()=>import('../views/products/patients.vue')
    },
    {
        path: '/consumer',
        name: 'Consumer',
        component: () => import('../views/products/consumer.vue')
    },
    {
        path: '/toolbox',
        name: 'Toolbox',
        component: () => import('../views/products/toolbox.vue')
    },
    // solutions
          {
        path: '/qual',
        name: 'Qualitative',
        component: () => import('../views/solutions/menu/qual.vue')
    },
         {
        path: '/TreatmentSynopsis',
        name: 'Treatment Synopsis',
        component: () => import('../views/solutions/Syndicated/Treatment.vue')
    },
        {
        path: '/Report',
        name: 'Patient Journeys Report ',
        component: () => import('../views/solutions/Syndicated/Report.vue')
    },
          {
        path: '/quant',
        name: 'Quantitative',
        component: () => import('../views/solutions/menu/quant.vue')
    },
             {
        path: '/industry',
        name: 'Industry Expertise',
        component: () => import('../views/solutions/menu/industry.vue')
    },
             {
        path: '/specialist',
        name: 'Specialist Solutions',
        component: () => import('../views/solutions/menu/specialist.vue')
    },
    {
        path: '/interview',
        name: 'IDI In-Depth Interview',
        component: () => import('../views/solutions/Qualitative/interview.vue')
    },
    {
        path: '/focus',
        name: 'Focus Group',
        component: () => import('../views/solutions/Qualitative/focus.vue')
    },
    {
        path: '/ethnography',
        name: 'Ethnography',
        component: () => import('../views/solutions/Qualitative/ethnography.vue')
    },
    {
        path: '/bulletin',
        name: 'Online Bulletin Board',
        component: () => import('../views/solutions/Qualitative/bulletin.vue')
    },
    {
        path: '/gangsurvey',
        name: 'Gang Survey',
        component: () => import('../views/solutions/Qualitative/survey.vue')
    },
    {
        path: '/onlinesurvey',
        name: 'Online Survey',
        component: () => import('../views/solutions/Quantitative/survey.vue')
    },
    {
        path: '/modeling',
        name: 'Modeling & Analytics',
        component: () => import('../views/solutions/Quantitative/modeling.vue')
    },
    {
        path: '/programming',
        name: 'Programming & Data Processing',
        component: () => import('../views/solutions/Quantitative/programming.vue')
    },
    {
        path: '/healthcare',
        name: 'Healthcare',
        component: () => import('../views/solutions/Industry/healthcare.vue')
    },
    {
        path: '/medTech',
        name: 'MedTech',
        component: () => import('../views/solutions/Industry/MedTech.vue')
    },
    {
        path: '/industryConsumer',
        name: 'Industry Consumer',
        component: () => import('../views/solutions/Industry/consumer.vue')
    },
    {
        path: '/respondent',
        name: 'Respondent Recruiting',
        component: () => import('../views/solutions/Solutions/respondent.vue')
    },
    {
        path: '/researchcommunity',
        name: 'Bespoke research Community',
        component: () => import('../views/solutions/Solutions/research.vue')
    },
    {
        path: '/glossary',
        name: 'Glossary',
        component: () => import('../views/Resources/Glossary.vue')
    },
    {
        path: '/reNews',
        name: 'ReNews',
        component: () => import('../views/Resources/news.vue')
    },
    {
        path: '/events',
        name: 'Events',
        component: () => import('../views/Resources/events.vue')
    },
     {
        path: '/whitePaper',
        name: 'White Paper & Case Study',
        component: () => import('../views/Resources/whitePaper.vue')
    },
     {
        path: '/videos',
        name: 'Videos / Interviews',
        component: () => import('../views/Resources/videos.vue')
    },
       {
        path: '/panel',
        name: 'Panel',
        component: () => import('../views/Resources/panel.vue')
    },
    {
        path: '/privacyPolicy',
        name: 'Privacy Policy',
        component: () => import('../views/privacyPolicy.vue')
    },
    {
        path: '/terms',
        name: 'Terms of Use',
        component: () => import('../views/TermsofUse.vue')
    },{
        path: '/case',
        name: 'caseShare',
        component: () => import('../views/case/caseList.vue')
    },
    ,{
        path: '/casedetail',
        name: 'caseDetail',
        component: () => import('../views/case/caseDetail.vue')
    },
    {
        path: '/media',
        name: 'mediaDetail',
        component: () => import('../views/media/mediaDetail.vue')
    },
    {
        path: '/newsDetail',
        name: 'newsDetail',
        component: () => import('../views/media/newsDetail.vue')
    },
        {
        path: '/downloadpage',
        name: 'downloadpage',
        component: () => import('../views/media/downloadpage.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/contact.vue')
    },
      {
        path: '/landingpage',
        name: 'LandingPage',
        component: () => import('../views/landingpage.vue')
    },
    {
        path: '/equote',
        name: 'equote',
            component:()=>import('@/views/logon/logon')
    },
    {
        path: '/register',
        name: 'register',
            component:()=>import('@/views/logon/register')
    
    },
     {
        path: '/forgetpassword',
        name: 'forgetpassword',
            component:()=>import('@/views/logon/forgetPassword')
    
    },
    {
        path: '/table',
        name: 'Table',
        component:()=>import('@/views/logon/table')
    },
    // {
    //     path: '/interaction',
    //     name: 'Interaction',
    //     component:()=>import('@/views/logon/interaction')
    // },
    // {
    //     path: '/form',
    //     name: 'logonform',
    //         component:()=>import('@/views/logon/form')
    
    // },
      {
        path: '/rfq',
        name: 'RFQ',
            component:()=>import('@/views/logon/rfq')
    
    },
       {
        path: '/setPassword',
        name: 'setPassword',
            component:()=>import('@/views/logon/password')
    
    },
       {
           path: "/cn",
           name: "ZH",
           redirect: "/cn/index",
           component:() => import('../layout/index'),
           children: [
               {
               path: "index",
               name: "cnIndex",
               component: () => import('@/views/cn/Index.vue')
               },
                  {
               path: "team",
               name: "cnCompany",
               component: () => import('@/views/cn/company/team.vue')
               },
                  {
               path: "aboutUs",
               name: "cnaboutUs",
               component: () => import('@/views/cn/company/aboutUs.vue')
               },
                     {
               path: "asia",
               name: "cnasia",
               component: () => import('@/views/cn/company/Asia.vue')
               },
                 {
        path: '/cn/qual',
        name: 'cnQualitative',
        component: () => import('../views/cn/solutions/menu/qual.vue')
    },
          {
        path: '/cn/quant',
        name: 'cnQuantitative',
        component: () => import('../views/cn/solutions/menu/quant.vue')
    },
             {
        path: '/cn/industry',
        name: 'cnIndustry Expertise',
        component: () => import('../views/cn/solutions/menu/industry.vue')
    },
             {
        path: '/cn/specialist',
        name: 'cnSpecialist Solutions',
        component: () => import('../views/cn/solutions/menu/specialist.vue')
               },
     {
        path: '/cn/panel',
        name: 'cnPanel',
        component: () => import('../views/cn/Resources/panel.vue')
    },
                   {
        path: 'media',
        name: 'cnmediaDetail',
        component: () => import('../views/cn/media/mediaDetail.vue')
    },
    {
        path: 'newsDetail',
        name: 'cnnewsDetail',
        component: () => import('../views/cn/media/newsDetail.vue')
    },
                                            {
               path: "physicians",
               name: "cnphysicians",
               component: () => import('@/views/cn/products/physicians.vue')
               },
                                                            {
               path: "consumer",
               name: "cnconsumer",
               component: () => import('@/views/cn/products/consumer.vue')
               },
                                                                            {
               path: "patients",
               name: "cnpatients",
               component: () => import('@/views/cn/products/patients.vue')
               },
                                                                                            {
               path: "toolbox",
               name: "cntoolbox",
               component: () => import('@/views/cn/products/toolbox.vue')
               },
                                                                                             {
        path: 'interview',
        name: 'cn IDI In-Depth Interview',
        component: () => import('../views/cn/solutions/Qualitative/interview.vue')
    },
    {
        path: 'focus',
        name: 'cn Focus Group',
        component: () => import('../views/cn/solutions/Qualitative/focus.vue')
    },
    {
        path: 'ethnography',
        name: 'cn Ethnography',
        component: () => import('../views/cn/solutions/Qualitative/ethnography.vue')
    },
    {
        path: 'bulletin',
        name: 'cn Online Bulletin Board',
        component: () => import('../views/cn/solutions/Qualitative/bulletin.vue')
    },
    {
        path: 'gangsurvey',
        name: 'cn Gang Survey',
        component: () => import('../views/cn/solutions/Qualitative/survey.vue')
    },
    {
        path: 'onlinesurvey',
        name: 'cn Online Survey',
        component: () => import('../views/cn/solutions/Quantitative/survey.vue')
    },
    {
        path: 'modeling',
        name: 'cn Modeling & Analytics',
        component: () => import('../views/cn/solutions/Quantitative/modeling.vue')
    },
    {
        path: 'programming',
        name: 'cn Programming & Data Processing',
        component: () => import('../views/cn/solutions/Quantitative/programming.vue')
    },
    {
        path: 'healthcare',
        name: 'cn Healthcare',
        component: () => import('../views/cn/solutions/Industry/healthcare.vue')
    },
    {
        path: 'medTech',
        name: 'cn MedTech',
        component: () => import('../views/cn/solutions/Industry/MedTech.vue')
    },
    {
        path: 'industryConsumer',
        name: 'cn Industry Consumer',
        component: () => import('../views/cn/solutions/Industry/consumer.vue')
    },
    {
        path: 'respondent',
        name: 'cn Respondent Recruiting',
        component: () => import('../views/cn/solutions/Solutions/respondent.vue')
    },
    {
        path: 'researchcommunity',
        name: 'cn Bespoke research Community',
        component: () => import('../views/cn/solutions/Solutions/research.vue')
    },{
        path: 'glossary',
        name: 'cnGlossary',
        component: () => import('../views/cn/Resources/Glossary.vue')
    },
    {
        path: 'reNews',
        name: 'cnReNews',
        component: () => import('../views/cn/Resources/news.vue')
    },
    {
        path: 'events',
        name: 'cnEvents',
        component: () => import('../views/cn/Resources/events.vue')
    },
     {
        path: 'whitePaper',
        name: 'cn White Paper & Case Study',
        component: () => import('../views/cn/Resources/whitePaper.vue')
    },
     {
        path: 'videos',
        name: 'cn Videos / Interviews',
        component: () => import('../views/cn/Resources/videos.vue')
               },
      {
        path: 'webinar',
        name: 'cnWebinars',
        component: () => import('../views/cn/webinar.vue')
    },   {
        path: 'contact',
        name: 'cnContact',
        component: () => import('../views/cn/contact.vue')
               },
               
               {
        path: 'equote',
        name: 'cnequote',
            component:()=>import('@/views/cn/logon/logon')
    
    },
    {
        path: 'register',
        name: 'cnregister',
            component:()=>import('@/views/cn/logon/register')
    
               },
    {
        path: 'activity',
        name: 'cnactivity',
            component:()=>import('@/views/cn/activity')
    
               },
       {
        path: 'activityFinished',
        name: 'cnactivityFinished',
            component:()=>import('@/views/cn/activityFinished')
    
               },
        {
        path: 'international',
        name: 'cninternational',
            component:()=>import('@/views/cn/solutions/Solutions/international')
    
               },
        {
        path: 'roadmap',
        name: 'cnroadmap',
            component:()=>import('@/views/cn/solutions/Solutions/roadmap')
    
    },
           ]
       }
]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if(savedPosition) {
            return savedPosition
        }
        else{
            return{x:0,y:0}
        }
    },
    routes
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
    // router.replace(router.history.pending.fullPath);
  }else{
    console.log(error)
  }
});

export default router
